"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.GpsStatus=void 0;var t;(function(e){e.Disabled="DISABLED",e.Enabled="ENABLED",e.TimedOut="TIMED_OUT"})(t||(exports.GpsStatus=t={}));
//# sourceMappingURL=GpsStatus.js.map
